'use strict';

var when = require('./when');
var NotFoundError = require('../errors/notFoundError');

module.exports = {
  done: done,
  failed: failed,
  pending: pending,
  notFound: notFound
};

function pending(id, store) {
  return fetchResult({
    id: id,
    pending: true,
    status: 'PENDING'
  }, store);
}

function failed(error, id, store) {
  return fetchResult({
    id: id,
    error: error,
    failed: true,
    status: 'FAILED'
  }, store);
}

function done(result, id, store) {
  return fetchResult({
    id: id,
    done: true,
    status: 'DONE',
    result: result
  }, store);
}

function notFound(id, store) {
  return failed(new NotFoundError(), id, store);
}

function fetchResult(initialResult, store) {
  initialResult.when = when;
  initialResult.toPromise = toPromise;
  initialResult._isFetchResult = true;

  if (store) {
    initialResult.store = store.displayName || store.id;
  }

  return initialResult;

  function toPromise() {
    return new Promise(function (resolve, reject) {
      var listener = undefined;

      if (!tryResolveFetch(initialResult) && store) {
        listener = store.addFetchChangedListener(tryResolveFetch);
      }

      function tryResolveFetch(latestResult) {
        if (latestResult.id !== initialResult.id) {
          return;
        }

        if (latestResult.done) {
          initialResult.done = true;
          initialResult.pending = false;
          initialResult.status = 'DONE';
          initialResult.result = latestResult.result;

          resolve(latestResult.result);
        } else if (latestResult.failed) {
          initialResult.failed = true;
          initialResult.pending = false;
          initialResult.status = 'FAILED';
          initialResult.error = latestResult.error;

          reject(latestResult.error);
        } else {
          return false;
        }

        if (listener) {
          listener.dispose();
        }

        return true;
      }
    });
  }
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/marty-lib/modules/store/fetch.js
 ** module id = 140
 ** module chunks = 0
 **/